import { checkSSO } from './check-sso';
import { Environment } from './environment.interface';

// Chat configurations to be used when in prod

export const environment: Environment = {
  production: true,
  intercom: 'zz7w3hpp',
  tasks: true,
  giftcardImport: true,
  customerImport: true,
  customerDeactivation: true,
  customerResetCredits: true,
  googleAnalyticsTrackId: 'UA-108353784-1',
  giftcardsDelete: true,
  voidReasons: true,
  enableSSO: checkSSO(),
  authService: '/PosServer/rest/internal/v1/sso/login/manager',
  masUIscriptUrl:
    'https://ls-mfe-assets-cdn.lightspeed.app/merchant-account-space/v0/latest.js',
  masTestMode: false,
  masShowCancelSubscriptionButton: false
};
